import { CLAdminSideBarConstants } from 'constants/SideBarConstants';
import { pagePaths } from 'constants/path';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoginStore } from 'store/useLoginDataStore';
import { NormalLNBButton } from 'styles/Global/buttonStyles';
import { AccountLevel } from 'utils/statusCode';

const CLAdminSideBar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { loginData } = useLoginStore();

    const [path, setPath] = useState('');
    const isAdminAccount = loginData.level === AccountLevel.admin;

    // sidebar hover 및 selected 적용을 위한 useEffect
    useEffect(() => {
        if (pathname === pagePaths.viewDetailPatient) {
            return setPath(pagePaths.managingPatients);
        } else if (pathname === pagePaths.viewDetaildiagnosis) {
            return setPath(pagePaths.diagnosisList);
        } else if (pathname.startsWith(pagePaths.CLAdminPatientInfoBase)) {
            return setPath(pagePaths.CLAdminManagePatient);
        } else if (pathname.startsWith(pagePaths.CLAdminUserDetailBase)) {
            return setPath(pagePaths.CLAdminUserLookup);
        }
        return setPath(pathname);
    }, [pathname]);

    // 조건에 따라 sidebar 클릭 시 modal 띄우기
    const handleSideBarOnModal = (nowPagePath: string, listPath: string) => {
        return navigate(listPath);
    };

    return (
        <>
            {CLAdminSideBarConstants(path, isAdminAccount).map((list, idx) => {
                // if (list.isDivider) {
                //     return <Divider key={`divider-${idx}`} />;
                // }
                if (!list.path) return null;

                return (
                    <NormalLNBButton key={idx} $idx={idx} $path={path} $listPath={list.path} onClick={() => handleSideBarOnModal(pathname, list.path)}>
                        {list.icon}
                        <span>{list.name}</span>
                    </NormalLNBButton>
                );
            })}
        </>
    );
};

export default CLAdminSideBar;
